


































import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import KUTE from "kute.js";

import WelcomePage from "@/components/chapters/WelcomePage.vue";
import GoToDesktop from "@/components/chapters/GoToDesktop.vue";
import Introduction from "@/components/chapters/Introduction.vue";
import Breath from "@/components/chapters/Breath.vue";
import DragDrop from "@/components/chapters/DragDrop.vue";
import MoreSenses from "@/components/chapters/MoreSenses.vue";
import Greatful from "@/components/chapters/Greatful.vue";
import Outro from "@/components/chapters/Outro.vue";
import EndScreen from "@/components/chapters/EndScreen.vue";
import TransitionWobble from "@/components/wobble/TransitionWobble.vue";
import {
  Gradient,
  Point,
  TransitionWobbleProps,
} from "@/components/wobble/model";

@Component({
  components: {
    WelcomePage,
    GoToDesktop,
    Introduction,
    Breath,
    DragDrop,
    MoreSenses,
    Greatful,
    Outro,
    EndScreen,
    TransitionWobble,
  },
})
export default class FullPageScroll extends Vue {
  public inMove = false; // If we are scrolling (independent of wobble transition!)
  public offsets: number[] = [];
  public touchStartY = 0;
  public scrollTop = 0;

  public chapters = [
    "WelcomePage",
    "Introduction",
    "Breath",
    "DragDrop",
    "MoreSenses",
    "Outro",
    "EndScreen",
  ];

  public lockedScroll = false;

  public twProps: TransitionWobbleProps = {
    sourcePath: undefined,
    targetPath: undefined,
    sourceGradient: undefined,
    targetGradient: undefined,
    sourceOrigin: undefined,
    targetOrigin: undefined, // new Point(0, 0),
    sourceSize: undefined,
    targetSize: undefined,
  };

  get hasStartedFlow() :boolean {
    return this.activeSection > 0;
  }

  get canScroll(): boolean {
    return !this.lockedScroll && !this.inMove;
  }

  get isTwPropsValid() {
    return Object.values(this.twProps).every(
      (prop: any) => prop !== undefined && prop !== null
    );
  }

  calculateSectionOffsets() {
    let sections = document.getElementsByTagName("section");
    for (const section of sections) {
      this.offsets.push(section.offsetTop);
    }
  }

  handleMouseWheel(e: any) {
    if (e.wheelDeltaY > 0 && this.canScroll) {
      this.moveUp();
    } else if (e.wheelDeltaY < 0 && this.canScroll) {
      this.moveDown();
    }
    e.preventDefault();
    return false;
  }

  handleMouseWheelDOM(e: any) {
    if (e.detail > 0 && this.canScroll) {
      this.moveUp();
    } else if (e.detail < 0 && this.canScroll) {
      this.moveDown();
    }

    return false;
  }

  get activeSection(): number {
    return this.$root.$data.activeSection;
  }

  set activeSection(idx: number) {
    this.$root.$data.activeSection = idx;
  }

  moveUp() {
    // Block all calls to move up. Dead code can be reactivated for debugging etc.
    return;
    /*
      if(this.activeSection === 0) {
        // We are already at the top.
        return;
      }
      this.inMove = true;
      // Note that scrolling up is only intended for testing.
      // Public version should block all calls to moveUp().
      this.scrollToSection(this.activeSection - 1);
    */
  }

  moveDown() {
    if (this.activeSection === this.chapters.length - 1) {
      // We are already at the bottom.
      return;
    }

    if (this.$vuetify.breakpoint.xsOnly && this.activeSection === 0) {
      // Never scroll on mobile as we don't allow using this app on mobile.
      return;
    }

    const svgs = document.querySelectorAll(".chapter .floating-wobble-svg");
    const paths = document.querySelectorAll(".chapter .floating-wobble-path");
    const gradientCoordinates = document.querySelectorAll(
      ".chapter .floating-wobble-gradient"
    );
    const gradientStarts = document.querySelectorAll(
      ".chapter .floating-wobble-gradient-start"
    );
    const gradientStops = document.querySelectorAll(
      ".chapter .floating-wobble-gradient-stop"
    );

    const currentSvg = svgs[this.activeSection];
    const currentPath = paths[this.activeSection];
    const currentGradientCoordinates = gradientCoordinates[this.activeSection];
    const currentGradientStart = gradientStarts[this.activeSection];
    const currentGradientStop = gradientStops[this.activeSection];
    const nextSvg = svgs[this.activeSection + 1];
    const nextPath = paths[this.activeSection + 1];
    const nextGradientCoordinates = gradientCoordinates[this.activeSection + 1];
    const nextGradientStart = gradientStarts[this.activeSection + 1];
    const nextGradientStop = gradientStops[this.activeSection + 1];

    this.twProps = {
      sourcePath: currentPath?.getAttribute("d"),
      targetPath: nextPath?.getAttribute("d"),
      sourceGradient: new Gradient(
        currentGradientStart.getAttribute("stop-color")!,
        currentGradientStop.getAttribute("stop-color")!,
        parseFloat(currentGradientStart.getAttribute("offset")!),
        parseFloat(currentGradientStop.getAttribute("offset")!),
        parseFloat(currentGradientCoordinates.getAttribute("x1")!),
        parseFloat(currentGradientCoordinates.getAttribute("y1")!),
        parseFloat(currentGradientCoordinates.getAttribute("x2")!),
        parseFloat(currentGradientCoordinates.getAttribute("y2")!)
      ),
      targetGradient: new Gradient(
        nextGradientStart.getAttribute("stop-color")!,
        nextGradientStop.getAttribute("stop-color")!,
        parseFloat(nextGradientStart.getAttribute("offset")!),
        parseFloat(nextGradientStop.getAttribute("offset")!),
        parseFloat(nextGradientCoordinates.getAttribute("x1")!),
        parseFloat(nextGradientCoordinates.getAttribute("y1")!),
        parseFloat(nextGradientCoordinates.getAttribute("x2")!),
        parseFloat(nextGradientCoordinates.getAttribute("y2")!)
      ),
      sourceOrigin: new Point(
        currentSvg?.getBoundingClientRect()?.x,
        currentSvg?.getBoundingClientRect()?.y
      ),
      targetOrigin: new Point(
        nextSvg?.getBoundingClientRect()?.x,
        nextSvg?.getBoundingClientRect()?.y - this.$vuetify.breakpoint.height
      ),
      sourceSize: new Point(
        currentSvg?.getBoundingClientRect()?.width,
        currentSvg?.getBoundingClientRect()?.height
      ),
      targetSize: new Point(
        nextSvg?.getBoundingClientRect()?.width,
        nextSvg?.getBoundingClientRect()?.height
      ),
    };
    this.$root.$data.inTransition = true;

    this.scrollToSection(this.activeSection + 1);
  }

  onTransitionCompleted() {
    this.$root.$data.inTransition = false;
  }

  hideWobbleOfActiveChapter() {
    const wobbles = document.querySelectorAll(".chapter .floating-wobble");
    // @ts-ignore
    wobbles[this.activeSection].style.visibility = "hidden";
  }

  showWobbleOfActiveChapter() {
    const wobbles = document.querySelectorAll(".chapter .floating-wobble");
    // @ts-ignore
    wobbles[this.activeSection].style.visibility = "visible";
  }

  scrollToSection(id: number) {
    this.activeSection = id;
    this.inMove = true;

    // Introduce a new attr into body to animate the scrolltop as a raw value
    const scrollAnimation = KUTE.fromTo(
      document.body,
      {
        attr: {
          scrolltop:
            document.getElementsByTagName("section")[id - 1].offsetTop ?? 0,
        },
      },
      {
        attr: {
          scrolltop: document.getElementsByTagName("section")[id].offsetTop,
        },
      },
      {
        duration: 2000,
        easing: "easingSinusoidalInOut",
        onUpdate: () => {
          const bodyAttrScroll = Array.prototype.slice
            .call(document.body.attributes)
            .find((e) => e.name === "scrolltop");
          if (!bodyAttrScroll) {
            return;
          }
          // Override the real scrollTop of the  body element
          document.body.scrollTop = bodyAttrScroll.value;
          this.scrollTop = bodyAttrScroll.value;
        },
      }
    );
    scrollAnimation.start();

    setTimeout(() => {
      this.inMove = false;
    }, 2100);
  }

  touchStart(e: any) {
    e.preventDefault();
    this.touchStartY = e.touches[0].clientY;
  }

  touchMove(e: any) {
    if (!this.canScroll) return false;
    e.preventDefault();

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - this.touchStartY;

    if (deltaY < 30) {
      this.moveDown();
    } else if (deltaY > 30) {
      this.moveUp();
    }

    this.touchStartY = 0;
    return false;
  }

  public lockScroll() {
    this.lockedScroll = true;
  }

  public releaseScroll() {
    this.lockedScroll = false;
  }

  public handleResize(e: any) {
    const innerHeight = e.target?.innerHeight;
    if (!innerHeight) {
      return;
    }
    document.body.scrollTop = innerHeight * this.activeSection;
    this.scrollTop = document.body.scrollTop;
  }

  created() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    window.addEventListener("mousewheel", this.handleMouseWheel, {
      passive: false,
    }); // Other browsers
    window.addEventListener("touchstart", this.touchStart, { passive: false }); // mobile devices
    window.addEventListener("touchmove", this.touchMove, { passive: false }); // mobile devices
  }

  mounted() {
    this.calculateSectionOffsets();
    // Set the scroll position in case we navigated away from the main page and return to it now.
    document.body.scrollTop =
      document.getElementsByTagName("section")[this.activeSection].offsetTop;
  }

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("mousewheel", this.handleMouseWheel); // Other browsers
    window.removeEventListener("DOMMouseScroll", this.handleMouseWheelDOM); // Mozilla Firefox
    window.removeEventListener("touchstart", this.touchStart); // mobile devices
    window.removeEventListener("touchmove", this.touchMove); // mobile devices
  }
}
